import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appName'
})
export class AppNamePipe implements PipeTransform {

  transform(appId: any, applicationArray: any): any {
    var appName = "";
    applicationArray.forEach(app => {
      if(app._id == appId)
      {
        appName = app.name;
      }
    });
    return appName;
  }

}
